import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { DivElement } from './styles';
import { TableControls } from '../../../../BaseEditor';
import { fieldsPropType } from './PropTypes';

function BodyComponent({
  row, fields, rowNumber, onChange, active, onClick,
}) {
  const cr = (rowNumber * 1 + 2);
  const globalProps = {
    onClick: (e) => onClick(e, rowNumber),
  };
  const globalStyle = active ? {
    background: active ? 'linear-gradient(0deg,rgba(255,255,255,0.7),rgba(255,255,255,0.7)),#008F21' : 'initial',
  } : {};
  return (
    <>
      <DivElement
        style={{
          ...globalStyle,
          gridArea: `${cr} / payer`,
        }}
        {...globalProps}
      >
        <TableControls.ItemPicker
          value={row.payer}
          onChange={(e, v) => onChange(e, rowNumber, { payer: v })}
          readOnly={fields.payer.read_only}
          backend="/api/catalog/payers/"
        />
      </DivElement>
      <DivElement
        style={{
          ...globalStyle,
          gridArea: `${cr} / kdb`,
        }}
        {...globalProps}
      >
        <TableControls.ItemPicker
          value={row.kdb}
          onChange={(e, v) => onChange(e, rowNumber, { kdb: v })}
          readOnly={fields.kdb.read_only}
          backend="/api/catalog/kdbs/"
        />
      </DivElement>
      <DivElement
        style={{
          ...globalStyle,
          gridArea: `${cr} / proportion`,
        }}
        {...globalProps}
      >
        <TableControls.NumerInput
          value={Number(row.proportion)}
          onChange={(e, v) => onChange(e, rowNumber, { proportion: v.toFixed(2) })}
          readOnly={fields.proportion.read_only}
          precision={2}
        />
      </DivElement>
      <DivElement
        style={{
          ...globalStyle,
          gridArea: `${cr} / dimension`,
        }}
        {...globalProps}
      >
        <TableControls.Selector
          value={row.dimension}
          onChange={(e, v) => onChange(e, rowNumber, { dimension: v })}
          readOnly={fields.dimension.read_only}
          values={fields.dimension.choices}
        />
      </DivElement>
      <DivElement
        style={{
          ...globalStyle,
          gridArea: `${cr} / is_basic`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        {...globalProps}
      >
        <TableControls.CheckboxInput
          value={Number(row.is_basic)}
          onChange={(e, v) => onChange(e, rowNumber, { is_basic: v })}
          readOnly={fields.is_basic.read_only}
        />
      </DivElement>
    </>
  );
}

BodyComponent.propTypes = {
  row: PropTypes.shape({
    payer: PropTypes.shape({ id: PropTypes.number }),
    kdb: PropTypes.shape({ id: PropTypes.number }),
    proportion: PropTypes.string,
    dimension: PropTypes.string,
    is_basic: PropTypes.bool,
  }),
  fields: fieldsPropType,
  rowNumber: PropTypes.number,
  onChange: PropTypes.func,
  active: PropTypes.bool,
  onClick: PropTypes.func,
};

BodyComponent.defaultProps = {
  row: {
    date: '',
    order_amount: 0,
    payment_notes: '',
  },
  fields: {
    date: {},
    order_amount: {},
    payment_notes: {},
  },
  rowNumber: 0,
  onChange: () => null,
  active: false,
  onClick: () => null,
};

export default memo(BodyComponent);
